module.exports = __webpack_public_path__ + "img/multi_image02.9ab378f9.png";